import Link from 'next/link';
import { z } from 'zod';

import LogoFull from '~/assets/vector/logo-full.svg';
import MenuItem from '~/components/molecules/menu/MenuItem';
import { modelMenu } from '~/lib/api/models';
import routeGenerator from '~/lib/api/routes';

import NewsletterForm from './NewsletterForm';

interface Props {
  menu?: z.infer<typeof modelMenu.schema>['menu'];
}

const MainFooterNav: React.FC<Props> = ({ menu }) => {
  return (
    <>
      <Link href={routeGenerator.homepage()} aria-label="Accueil">
        <LogoFull className="h-16" />
      </Link>

      <div className="relative">
        <NewsletterForm />
      </div>

      <div className="relative">
        {menu && (
          <ul className="grid grid-cols-3 gap-x-6 gap-y-4 text-xs sm:flex sm:flex-row sm:gap-x-4">
            {menu.menuItems.edges.map((item) => (
              <li key={item.node.id}>
                <MenuItem
                  item={item.node}
                  className="text-center sm:text-start"
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default MainFooterNav;
